const configMember = {
    homemember: {
        listLayout: 'MemberListHomeLayout',
        emptyLayout: 'MemberEmptyDefaultLayout',
        getFunc: 'getMember',
        listApiParamSet: {
            opf: 1,
            di: 1,
            al: 1
        },
    },
    member: {
        listLayout: 'MemberListDefaultLayout',
        emptyLayout: 'MemberEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        filterLayout: 'MemberFilterDefaultLayout',
        getFunc: 'getMember',
        listApiParamSet: {
            ip: 1,
            sp: 1,
            opf: 1,
            al:1
        },
        pageRow: 10,
    },

}

export default {
    methods: {
        returnMemberConfig(type) {
            return configMember[type];
        }
    },
    filterConfig: {
        ac: {
            type: 'match',
            classname: 'filterSi',
        },
        tab: {
            type: 'match',
            classname: 'tab',
        }
    }
}